var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"org-manage"},[(_vm.org)?_c('pvcam-wc-node-manager',{attrs:{"vehicle":false,"user":false,"org":_vm.org,"reenter":_vm.reenter},on:{"autocomplete":_vm.autocomplete}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }